export class StateDistrictList {
  stateList: string[] = [
    'ANDAMAN & NICOBAR',
    'ANDHRA PRADESH',
    'ARUNACHAL PRADESH',
    'ASSAM',
    'BIHAR',
    'CHANDIGARH',
    'CHATTISGARH',
    'DADRA NAGARHAVELI',
    'DAMAN & DIU',
    'DELHI',
    'GOA',
    'GUJARAT',
    'HARYANA',
    'HIMACHAL PRADESH',
    'JAMMU & KASHMIR',
    'JHARKHAND',
    'KARNATAKA',
    'KERALA',
    'MADHYA PRADESH',
    'MAHARASHTRA',
    'MANIPUR',
    'MEGHALAYA',
    'MIZORAM',
    'NAGALAND',
    'ODISHA',
    'PUDUCHERRY',
    'PUNJAB',
    'RAJASTHAN',
    'SIKKIM',
    'TAMIL NADU',
    'TELANGANA',
    'TRIPURA',
    'UTTAR PRADESH',
    'UTTARAKHAND',
    'WEST BENGAL'
  ];
  districtList: string[] = [];

  createDistrictList(state: string) {
    this.districtList = [];
    switch (state) {
      case 'ANDAMAN & NICOBAR':
        this.districtList = [
          'Nicobar',
          'North & Middle Andaman',
          'South Andaman'
        ];
        break;
      case 'ANDHRA PRADESH':
        this.districtList = [
          'Alluri Sitharama Raju',
          'Anakapalli',
          'Annamayya',
          'Anantapur',
          'Bapatla',
          'Chittoor',
          'East Godavari',
          'Eluru',
          'Guntur',
          'Kakinada',
          'Kona Seema',
          'Krishna',
          'Kurnool',
          'Manayam',
          'Nandyal',
          'Nellore',
          'Ntr',
          'Palandu',
          'Prakasam',
          'Sri Balaji',
          'Sri Satyasai',
          'Srikakulam',
          'Vishakhapatnam',
          'Vizianagaram',
          'West Godavari',
          'Ysr Kadapa'
        ];
        break;
      case 'ARUNACHAL PRADESH':
         this.districtList = [
          'Changlang',
          'Dibang Valley',
          'East Khameng',
          'East Siang',
          'Kurung Kumey',
          'Lohit',
          'Longding',
          'Lower Dibang Valley',
          'Lower Subansiri',
          'Namsai',
          'Papumpare',
          'Tawang',
          'Tirap',
          'Upper Siang',
          'Upper Sibansiri',
          'West Kameng',
          'West Siang'
        ];
        break;
      case 'ASSAM':
        this.districtList = [
          'Baksa',
          'Barpeta',
          'Biswanath',
          'Bongaigaon',
          'Cachar',
          'Charaideo',
          'Chirang',
          'Darrang',
          'Dhemaji',
          'Dhuburi',
          'Dibrugarh',
          'Dima Hasao',
          'Goalpara',
          'Golaghat',
          'Hailakandi',
          'Hojai',
          'Jorhat',
          'Kamrup',
          'Kamrup Metro',
          'Karbi Anglong',
          'Karimganj',
          'Kokrajhar',
          'Lakhimpur',
          'Majuli',
          'Morigaon',
          'Nagaon',
          'Nalbari',
          'S Salmara Mankachar',
          'Sibsagar',
          'Sonitpur',
          'Tinsukia',
          'Udalguri',
          'West Karbi Anglong'
        ];
        break;
      case 'BIHAR':
        this.districtList = [
          'Araria',
          'Arwal',
          'Aurangabad',
          'Banka',
          'Begusarai',
          'Bhagalpur',
          'Bhojpur',
          'Buxar',
          'Darbhanga',
          'East Champaran',
          'Gaya',
          'Gopalganj',
          'Jahanabad',
          'Jamui',
          'Kaimur',
          'Katihar',
          'Khagaria',
          'Kishanganj',
          'Lakhisarai',
          'Luckeesarai',
          'Madhepura',
          'Madhubani',
          'Munger',
          'Muzaffarpur',
          'Nalanda',
          'Nawada',
          'Patna',
          'Purnia',
          'Rohtas',
          'Saharsa',
          'Samastipur',
          'Saran',
          'Sewan',
          'Sheikhpura',
          'Sheohar',
          'Sitamarhi',
          'Supaul',
          'Vaishali',
          'West Champaran'
        ];
        break;
      case 'CHANDIGARH':
        this.districtList = ['CHANDIGARH'];
        break;
      case 'CHATTISGARH':
        this.districtList = [
          'Balod',
          'Balodabazar',
          'Balrampur',
          'Bastar',
          'Bemetara',
          'Bijapur',
          'Bilaspur',
          'Dantewada',
          'Dhamtari',
          'Durg',
          'Gariyaband',
          'Janjgir',
          'Jashpur',
          'Kanker',
          'Kawardha',
          'Kondagaon',
          'Korba',
          'Koria',
          'Mahasamund',
          'Mungeli',
          'Narayanpur',
          'Purushottampur',
          'Raigarh',
          'Raipur',
          'Rajnandgaon',
          'Sukma',
          'Surajpur',
          'Surguja'
        ];
        break;
      case 'DADRA NAGARHAVELI':
        this.districtList = ['Silvassa'];
        break;
      case 'DAMAN & DIU':
        this.districtList = ['Daman', 'Diu'];
        break;
      case 'DELHI':
        this.districtList = [
          'Central DELHI',
          'DELHI Shahdara',
          'East DELHI',
          'New DELHI',
          'North DELHI',
          'North East DELHI',
          'North West DELHI',
          'South DELHI',
          'South East DELHI',
          'South West DELHI',
          'West DELHI'
        ];
        break;
      case 'GOA':
        this.districtList = ['North GOA', 'South GOA'];
        break;
      case 'GUJARAT':
        this.districtList = [
          'Ahmedabad',
          'Amreli',
          'Anand',
          'Aravalli',
          'Banas Kantha',
          'Bharuch',
          'Bhavnagar',
          'Botad',
          'Chhotaudepur',
          'Dahod',
          'Dangs',
          'Devbhumi Dwarka',
          'Gandhinagar',
          'Gir Somnath',
          'Jamnagar',
          'Junagadh',
          'Kheda',
          'Kutch',
          'Mahisagar',
          'Mehsana',
          'Morbi',
          'Narmada',
          'Navsari',
          'Panch Mahals',
          'Patan',
          'Porbandar',
          'Rajkot',
          'Sabar Kantha',
          'Surat',
          'Surendranagar',
          'Tapi',
          'The Dangs',
          'Vadodara',
          'Valsad'
        ];
        break;
      case 'HARYANA':
        this.districtList = [
          'Ambala',
          'Bhiwani',
          'Charki Dadri',
          'Faridabad',
          'Fatehabad',
          'Gurgaon',
          'Hisar',
          'Jhajjar',
          'Jind',
          'Kaithal',
          'Karnal',
          'Khewra',
          'Kurukshetra',
          'Mahendragarh',
          'Mewat',
          'Palwal',
          'Panchkula',
          'Panipat',
          'Rewari',
          'Rohtak',
          'Singar',
          'Sirsa',
          'Sonipat',
          'Yamunanagar'
        ];
        break;
      case 'HIMACHAL PRADESH':
        this.districtList = [
          'Bilaspur',
          'Chamba',
          'Hamirpur',
          'Kangra',
          'Kinnaur',
          'Kullu',
          'Lahul & Spiti',
          'Mandi',
          'Shimla',
          'Sirmaur',
          'Solan',
          'Una'
        ];
        break;
      case 'JAMMU & KASHMIR':
        this.districtList = [
          'Anantnag',
          'Badgam',
          'Bandipora',
          'Baramulla',
          'Doda',
          'Ganderbal',
          'Jammu',
          'Kargil',
          'Kathua',
          'Kishtwar',
          'Kulgam',
          'Kupwara',
          'Leh',
          'Poonch',
          'Pulwama',
          'Rajouri',
          'Ramban',
          'Reasi',
          'Samba',
          'Shopian',
          'Srinagar',
          'Udhampur'
        ];
        break;
      case 'JHARKHAND':
        this.districtList = [
          'Bokaro',
          'Chatra',
          'Deogarh',
          'Dhanbad',
          'Dumka',
          'East Singhbhum',
          'Garhwa',
          'Giridih',
          'Godda',
          'Gumla',
          'Hazaribagh',
          'Jamtara',
          'Khunti',
          'Kodarma',
          'Koderma',
          'Latehar',
          'Lohardaga',
          'Pakur',
          'Palamu',
          'Ramgarh',
          'Ranchi',
          'Sahibganj',
          'Saraikela Kharsawan',
          'Simdega',
          'West Singhbhum'
        ];
        break;
      case 'KARNATAKA':
        this.districtList = [
          'Bagalkot',
          'Bangalore',
          'Bangalore Rural',
          'Belgaum',
          'Bellary',
          'Bidar',
          'Bijapur',
          'Chamrajnagar',
          'Chikkaballapura',
          'Chikmagalur',
          'Chitradurga',
          'Dakshin Kannad',
          'Davangere',
          'Dharwad',
          'Gadag',
          'Gulbarga',
          'Hassan',
          'Haveri',
          'Kodagu',
          'Kolar',
          'Koppal',
          'Mandya',
          'Mysore',
          'Raichur',
          'Ramanagara',
          'Shimoga',
          'Tumkur',
          'Udupi',
          'Uttar Kannad',
          'Yadgir'
        ];
        break;
      case 'KERALA':
        this.districtList = [
          'Alappuzha',
          'Ernakulam',
          'Idukki',
          'Kannur',
          'Kasaragod',
          'Kollam',
          'Kottayam',
          'Kozhikode',
          'Lakshadweep',
          'Malappuram',
          'Palakkad',
          'Pathanamthitta',
          'Raichur',
          'Thiruvananthapuram',
          'Thrissur',
          'Wayanad'
        ];
        break;
      case 'MADHYA PRADESH':
        this.districtList = [
          'Agar',
          'Agar Malwa',
          'Alirajpur',
          'Anuppur',
          'Ashoknagar',
          'Badwani',
          'Balaghat',
          'Betul',
          'Bhind',
          'Bhopal',
          'Burhanpur',
          'Chhatarpur',
          'Chhindwara',
          'Damoh',
          'Datia',
          'Dewas',
          'Dhar',
          'Dindori',
          'Guna',
          'Gwalior',
          'Harda',
          'Hoshangabad',
          'Indore',
          'Jabalpur',
          'JahbuA',
          'Katni',
          'Khandwa',
          'Khargone',
          'Mandla',
          'Mandsaur',
          'Morena',
          'Narsimhapur',
          'Neemuch',
          'Niwari',
          'Panna',
          'Raisen',
          'Rajgarh',
          'Ratlam',
          'Rewa',
          'Sagar',
          'Satna',
          'Sehore',
          'Seoni',
          'Shahdol',
          'Shajapur',
          'Sheopur',
          'Shivpuri',
          'Sidhi',
          'Singrauli',
          'Tikamgarh',
          'Ujjain',
          'Umaria',
          'Vidisha'
        ];
        break;
      case 'MAHARASHTRA':
        this.districtList = [
          'Ahmadnagar',
          'Akola',
          'Alwar',
          'Amravati',
          'Aurangabad',
          'Beed',
          'Bhandara',
          'Bid',
          'Buldhana',
          'Chandrapur',
          'Dhule',
          'Gadchiroli',
          'Gondia',
          'Greater Mumbai',
          'Hingoli',
          'Jalgaon',
          'Jalna',
          'Kolhapur',
          'Latur',
          'Mumbai City',
          'Nagpur',
          'Nanded',
          'Nandurbar',
          'Nashik',
          'Osmanabad',
          'Palghar',
          'Parbhani',
          'Pune',
          'Raigarh',
          'Ratnagiri',
          'Sangli',
          'Satara',
          'Sindhudurg',
          'Solapur',
          'Thane',
          'Wardha',
          'Washim',
          'Yavatmal'
        ];
        break;
      case 'MANIPUR':
        this.districtList = [
          'Bishnupur',
          'Chandel',
          'Churachandpur',
          'East Imphal',
          'Jiribam',
          'Kakching',
          'Kamjong',
          'Kangpokpi',
          'Noney',
          'Pherzawl',
          'Senapati',
          'Tamenglong',
          'Tengnoupal',
          'Thoubal',
          'Ukhrul',
          'West Imphal'
        ];
        break;
      case 'MEGHALAYA':
        this.districtList = [
          'East Garo Hills',
          'East Jaintia Hills',
          'East Khasi Hills',
          'Jaintia Hills',
          'North Garo Hills',
          'Ri Bhoi',
          'South Garo Hills',
          'Southwest Khasi Hils',
          'South West Garo Hills',
          'West Garo Hills',
          'West Jaintia Hills',
          'West Khasi Hills'
        ];
        break;
      case 'MIZORAM':
        this.districtList = [
          'Aizawl',
          'Champhai',
          'Kolasib',
          'Lawngtlai',
          'Lunglei',
          'Mamit',
          'Saiha',
          'Serchhip'
        ];
        break;
      case 'NAGALAND':
        this.districtList = [
          'Dimapur',
          'Kiphire',
          'Kohima',
          'Longleng',
          'Mokokchung',
          'Mon',
          'Peren',
          'Phek',
          'Tuensang',
          'Wokha',
          'Zunheboto'
        ];
        break;
      case 'ODISHA':
        this.districtList = [
          'Angul',
          'Baleshwar',
          'Bargarh',
          'Bhadrak',
          'Bolangir',
          'Boudh',
          'Cuttack',
          'Deogarh',
          'Dhenkanal',
          'Gajapati',
          'Ganjam',
          'Jagatsinghpur',
          'Jajpur',
          'Jharsuguda',
          'Kalahandi',
          'Kandhamal',
          'Kendrapara',
          'Keonjhar',
          'Khordha',
          'Koraput',
          'Malkangiri',
          'Mayurbhanj',
          'Nabarangapur',
          'Nayagarh',
          'Nuaparha',
          'Puri',
          'Rayagada',
          'Sambalpur',
          'Sonapur',
          'Sundargarh'
        ];
        break;
      case 'Pondicherry':
        this.districtList = [
          'Karaikal', 
          'Mahe',
          'Pondicherry',
          'Yanam'];
        break;
      case 'PUNJAB':
        this.districtList = [
          'Amritsar',
          'Barnala',
          'Bathinda',
          'Faridkot',
          'Fatehgarh Sahib',
          'Fazilka',
          'Firozpur',
          'Gurdaspur',
          'Hoshiarpur',
          'Jalandhar',
          'Kapurthala',
          'Ludhiana',
          'Mansa',
          'Moga',
          'Muktsar',
          'Pathankot',
          'Patiala',
          'Rupnagar',
          'Sangrur',
          'SAS Nagar',
          'Shd Bhagat Singh Ngr',
          'Shimla',
          'Tarn Taran'
        ];
        break;
      case 'RAJASTHAN':
        this.districtList = [
          'Ajmer',
          'Alwar',
          'Banswara',
          'Baran',
          'Barmer',
          'Bharatpur',
          'Bhilwara',
          'Bikaner',
          'Bundi',
          'Chittaurgarh',
          'Churu',
          'Dausa',
          'Dungarpur',
          'Ganganagar',
          'Hanumangarh',
          'Jaipur',
          'Jaisalmer',
          'Jalore',
          'Jhalawar',
          'Jhunjhunun',
          'Jodhpur',
          'Kota',
          'Nagaur',
          'Pali',
          'Pratapgarh',
          'Rajsamand',
          'Sawaimadhopur',
          'Sikar',
          'Sirohi',
          'Tonk',
          'Udaipur',
          'Karauli',
          'Dholpur'
        ];
        break;
      case 'SIKKIM':
        this.districtList = [
          'East District',
          'North District',
          'South District',
          'West District'
        ];
        break;
      case 'TAMIL NADU':
        this.districtList = [
          'Ariyalur',
          'Chennai',
          'Chengalpattu',
          'Coimbatore',
          'Cuddalore',
          'Dharmapuri',
          'Dindigul',
          'Erode',
          'Kallakurichi',
          'Kancheepuram',
          'Kanniyakumari',
          'Karamadai',
          'Karur',
          'Krishnagiri',
          'Madurai',
          'Mayiladuthurai',
          'Nagapattinam',
          'Namakkal',
          'Nilgiris',
          'Perambalur',
          'Pudukkottai',
          'Ramanathapuram',
          'Ranipet',
          'Salem',
          'Sivaganga',
          'Tenkasi',
          'Thanjavur',
          'Theni',
          'Thiruvarur',
          'Thoothukudi',
          'Tiruchchirappalli',
          'Tirunelveli',
          'Tirupathur',
          'Tiruppur',
          'Tiruvallur',
          'Tiruvannamalai',
          'Tuticorin',
          'Vellore',
          'Viluppuram',
          'Virudhunagar'
        ];
        break;
      case 'TELANGANA':
        this.districtList = [
          'Adilabad',
          'Bhadradri Kothagudem',
          'Hyderabad',
          'Jagitial',
          'Jangaon',
          'Jayashankar Bhupalpa',
          'Jogulamba Gadwal',
          'Kamareddy',
          'Karim Nagar',
          'Khammam',
          'Komram Bheem Asifaba',
          'Mahabubabad',
          'Mancherial',
          'Medak',
          'Medchal Malkajgiri',
          'Mehabubnagar',
          'Nagarkurnool',
          'Nalgonda',
          'Nirmal',
          'Nizamabad',
          'Peddapalli',
          'Rajanna Sircilla',
          'Rangareddi',
          'Sangareddy',
          'Siddipet',
          'Suryapet',
          'Use Tg010',
          'Vikarabad',
          'Wanaparthy',
          'Warangal',
          'Warangal Rural',
          'Yadadri Bhuvanagiri'
        ];
        break;
      case 'TRIPURA':
        this.districtList = [
          'Dhalai',
          'Gomati',
          'Khowai',
          'North Tripura',
          'Sepahijhala',
          'South Tripura',
          'Unakoti',
          'West Tripura'
        ];
        break;
      case 'UTTAR PRADESH':
        this.districtList = [
          'Agra',
          'Akhlaaur',
          'Aligarh',
          'Allahabad',
          'Ambedkarnagar',
          'Amethi/Csm Nagar',
          'Amroha',
          'Auraiya',
          'Azamgarh',
          'Baghpat',
          'Bahraich',
          'Ballia',
          'Balrampur',
          'Banda',
          'Barabanki',
          'Bareilly',
          'Basti',
          'Bijnor',
          'Budaun',
          'Bulandshahr',
          'Chandauli',
          'Chitrakut',
          'Deoria',
          'Etah',
          'Etawah',
          'Faizabad',
          'Farrukkhabad',
          'Fatehpur',
          'Firozabad',
          'Gautam Budh Nagar',
          'Ghaziabad',
          'Ghazipur',
          'Gonda',
          'Gorakhpur',
          'Hamirpur',
          'Hapur',
          'Hardoi',
          'Hathras',
          'Jaipur',
          'Jalaun',
          'Jaunpur',
          'Jhansi',
          'Kannuaj',
          'Kanpur Nagar',
          'Kanpur Rural',
          'Kanpur Urban',
          'Kashi Ram Nagar',
          'Kaushambi',
          'Khekra',
          'Kushinagar',
          'Lakhimpur',
          'Lakhimpur Kheri',
          'Lalitpur',
          'Lucknow',
          'Maharajganj',
          'Mahoba',
          'Mainpuri',
          'Mathura',
          'Maunathbhanjan',
          'Meerut',
          'Mirzapur',
          'Moradabad',
          'Muzaffarnagar',
          'Pilibhit',
          'Pratapgarh',
          'Rae Bareli',
          'Rampur',
          'Saharanpur',
          'Sambhal',
          'Sant Kabir Nagar',
          'Sant Ravi Nagar',
          'Shahjahanpur',
          'Shamli',
          'Shikohabad',
          'Shravasti',
          'Sidharthnagar',
          'Sitapur',
          'Sonbhadra',
          'Sultanpur',
          'Unnao',
          'Varanasi'
        ];
        break;
      case 'UTTARAKHAND':
        this.districtList = [
          'Almora',
          'Bageshwar',
          'Chamoli',
          'Champawat',
          'Dehradun',
          'Haridwar',
          'Nainital',
          'Pauri',
          'Pithoragarh',
          'Rudraprayag',
          'Tehri Garhwal',
          'Udham Singh Nagar',
          'Uttarkashi'
        ];
        break;
      case 'WEST BENGAL':
        this.districtList = [
          'Alipurduar',
          'Bankura',
          'Birbhum',
          'Cooch Behar',
          'Dakshin Dinajpur',
          'Darjeeling',
          'Hoogly',
          'Howrah',
          'Jalpaiguri',
          'Jhargram',
          'Kalimpong',
          'Kolkata',
          'Malda',
          'Murshidabad',
          'Nadia',
          'North 24 Parganas',
          'Paschim Bardhaman',
          'Paschim Medinipur',
          'Purba Bardhaman',
          'Purba Medinipur',
          'Purulia',
          'South 24 Parganas',
          'Uttar Dinajpur'
        ];
        break;
    }
  }
}
